import {useEffect, useState} from 'react';

export function useDetectTouchDevice() {
  const [isTouch, setIsTouch] = useState<boolean>(isTouchDevice());

  useEffect(() => {
    const onTouchStart = () => {
      setIsTouch(true);
      window.removeEventListener('touchstart', onTouchStart);
    };

    window.addEventListener('touchstart', onTouchStart);

    return () => {
      window.removeEventListener('touchstart', onTouchStart);
    };
  }, []);

  return isTouch;
}

export function isTouchDevice(): boolean {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
